<template>
    <section aria-labelledby="payment-details-heading">
        <form
            class="mt-4 max-w-3xl rounded-lg border border-iron-200 bg-white p-3 sm:p-6"
            @submit.prevent="update"
        >
            <div class="grid grid-cols-4 gap-6">
                <div class="col-span-4 sm:col-span-2">
                    <div class="grid w-full items-center gap-1.5">
                        <Label for="company">{{
                            $t("billing.billing_information.company")
                        }}</Label>
                        <Input
                            id="company"
                            v-model="form.company"
                            type="text"
                        />
                    </div>
                </div>

                <div class="col-span-4 sm:col-span-2">
                    <div class="grid w-full items-center gap-1.5">
                        <Label for="email-address">{{
                            $t("billing.billing_information.email")
                        }}</Label>
                        <Input
                            id="email-address"
                            v-model="form.email"
                            type="email"
                            autocomplete="email"
                        />
                    </div>
                </div>

                <div class="col-span-4 sm:col-span-2">
                    <div class="grid w-full items-center gap-1.5">
                        <Label for="first-name">{{
                            $t("billing.billing_information.first_name")
                        }}</Label>
                        <Input
                            id="first-name"
                            v-model="form.first_name"
                            type="text"
                        />
                    </div>
                </div>

                <div class="col-span-4 sm:col-span-2">
                    <div class="grid w-full items-center gap-1.5">
                        <Label for="last-name">{{
                            $t("billing.billing_information.last_name")
                        }}</Label>
                        <Input
                            id="last-name"
                            v-model="form.last_name"
                            type="text"
                            autocomplete="last-name"
                        />
                    </div>
                </div>

                <div class="col-span-4 sm:col-span-2">
                    <div class="grid w-full items-center gap-1.5">
                        <Label for="city">{{
                            $t("billing.billing_information.city")
                        }}</Label>
                        <Input
                            id="city"
                            v-model="form.city"
                            type="text"
                            autocomplete="city"
                        />
                    </div>
                </div>

                <div class="col-span-4 sm:col-span-2">
                    <div class="grid w-full items-center gap-1.5">
                        <Label for="street">{{
                            $t("billing.billing_information.street")
                        }}</Label>
                        <Input
                            id="street"
                            v-model="form.street"
                            type="text"
                            autocomplete="street"
                        />
                    </div>
                </div>

                <div class="col-span-4 sm:col-span-2">
                    <CountrySelect
                        v-model="form.country"
                        :countries="countries"
                    >
                    </CountrySelect>
                </div>

                <div class="col-span-4 sm:col-span-2">
                    <div class="grid w-full items-center gap-1.5">
                        <Label for="postal-code">{{
                            $t("billing.billing_information.zip")
                        }}</Label>
                        <Input
                            id="postal-code"
                            v-model="form.postal_code"
                            type="text"
                            autocomplete="postal-code"
                        />
                    </div>
                </div>

                <div class="col-span-4 sm:col-span-2">
                    <div class="grid w-full items-center gap-1.5">
                        <Label for="tax_id">{{
                            $t("billing.billing_information.tax_id")
                        }}</Label>
                        <Input
                            id="tax_id"
                            v-model="form.tax_id"
                            type="text"
                            autocomplete="tax_id"
                        />
                    </div>
                </div>

                <div class="col-span-4 sm:col-span-2">
                    <div class="grid w-full items-center gap-1.5">
                        <Label for="crn">{{
                            $t("billing.billing_information.crn")
                        }}</Label>
                        <Input
                            id="crn"
                            v-model="form.crn"
                            type="text"
                            autocomplete="crn"
                        />
                    </div>
                </div>
            </div>
            <div class="mt-4 text-right">
                <Button type="submit">
                    {{ $t("save") }}
                </Button>
            </div>
        </form>
    </section>
</template>

<script lang="ts" setup>
import route from "ziggy-js";
import { BillingAddress } from "../types";
import { countries } from "./countries";
import { useForm } from "@inertiajs/vue3";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import CountrySelect from "./CountrySelect.vue";

const props = defineProps<{
    billingAddress: BillingAddress;
}>();

const form = useForm({
    email: props.billingAddress.email ?? "",
    company: props.billingAddress.company ?? "",
    first_name: props.billingAddress.first_name ?? "",
    last_name: props.billingAddress.last_name ?? "",
    city: props.billingAddress.city ?? "",
    street: props.billingAddress.street ?? "",
    country: props.billingAddress.country,
    postal_code: props.billingAddress.postal_code ?? "",
    tax_id: props.billingAddress.tax_id ?? "",
    crn: props.billingAddress.crn ?? "",
});

function update() {
    form.put(
        route("app.billing-addresses.update", {
            billingAddress: props.billingAddress.id,
        }),
    );
}
</script>
